import React from "react";
import banner from "../assets/banner.jpg"; // Ajusta la ruta si tu archivo está en otra ubicación

function Header() {
  return (
    <header className="bg-light border-bottom shadow-sm p-2 px-md-4">
      <div className="d-flex flex-column align-items-center">
        <img
          src={banner}
          alt="LemmonTags Banner"
          className="img-fluid rounded mb-2"
          style={{ 
            maxHeight: '180px',
            width: '100%',
            objectFit: 'cover',
            objectPosition: 'center'
          }}
        />
        <h1 className="h5 text-muted mb-0 fw-normal">Admin Panel</h1>
      </div>
    </header>
  );
}

export default Header;